module.exports = __webpack_public_path__ + "img/kdLogoM_CH.c3125956.png";